import { trackPageview } from "@/services/tracking/hardened"
import FaqPage from "./faq-page"
import createComponent from "@/utils/create-component"

export default () => {
  const el = document.getElementById("vue-spaces-faq")

  if (!el) {
    // prevent trying to mount the component when in another page
    return
  }

  createComponent({
    el: el,
    component: FaqPage
  })

  trackPageview()
}
